// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { ChangeEvent } from "react";
import { useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import FontIcon from "../../../../../../components/FontIcon";
import { NotifyMode } from "../../../../../notify/NotifyModeEnum";
import { useNotify } from "../../../../../notify/useNotify";

interface ProfileImageProps {
  onChange: any;
  src: string | undefined;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "relative",
  },
  avatar: {
    height: 80,
    width: 80,
    marginRight: theme.spacing(2),
    borderWidth: 1,
    borderColor: theme.palette.grey.A100,
    borderStyle: "solid",
  },
  label: {
    width: 30,
    height: 30,
    position: "absolute",
    top: 0,
    left: 72,
    transform: "translate(-50%,0)",
    paddingTop: 4,
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.2),
    paddingRight: theme.spacing(1),
    backgroundColor: "#fff2ce",
    cursor: "pointer",
    color: "#e6c224",
    flex: "0 0 auto",
    textAlign: "center",
    borderRadius: "50%",
    "& .material-icons": {
      fontSize: ".7em",
    },
    "&:hover": {
      background: "#ffecb6",
    },
  },
  loading: {
    border: "1px solid #ced4da",
    borderRadius: "50%",
    position: "absolute",
    left: 0,
    top: 0,
    height: 80,
    width: 80,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.palette.background.default,
  },
}));

export const WeduAvatar: FC<ProfileImageProps> = ({ onChange, src }) => {
  const classes = useStyles();
  const snackNotify = useNotify();
  const [key, setKey] = useState(Date.now());

  const accept = useMemo(() => "image/jpg,image/jpeg,image/png", []);
  const maxSize = useMemo(() => 5000, []);

  const reset = useCallback(() => {
    setKey(Date.now());
  }, []);

  const onImageChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      let file = e.target.files && e.target.files[0];

      if (file) {
        if (maxSize && maxSize < file.size / 1000) {
          reset();
          snackNotify("Error", "Max size 5MB", NotifyMode.ERROR);

          return;
        }

        if (!accept.split(",").includes(file.type)) {
          reset();
          snackNotify("Error", ".png,.jpg", NotifyMode.ERROR);

          return;
        }

        onChange(file);
      }

      reset();
    },
    [reset, maxSize, accept, onChange, snackNotify],
  );

  return (
    <div className={classes.root}>
      <Avatar className={classes.avatar} src={src} />
      {!!onChange && (
        <label className={classes.label} htmlFor="MyProfileImage_input">
          <FontIcon name={"edit"} color={"inherit"} />
          <input
            key={key}
            type="file"
            accept={accept}
            onChange={onImageChange}
            style={{ display: "none" }}
            id={"MyProfileImage_input"}
          />
        </label>
      )}
    </div>
  );
};
